import React, { ReactElement } from 'react';

const VisibleField: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement | null => {
  const {
    isActive,
    fieldName,
    hiddenFieldList,
    children,
  } = props;

  if (isActive) {
    const isVisible: boolean = hiddenFieldList && hiddenFieldList.length ? !hiddenFieldList.includes(fieldName) : true;

    if (!isVisible) {
      return null;
    }
  }

  return children;
});

export default VisibleField;
